<template lang="html">
    <div>
        <div v-if="isPricePerGroupPerGroup" class="mb-3">
            <div class="error">
                <span class="color-6">*</span>
                {{ perGroupRefundMsg }}
            </div>
        </div>

        <!-- PAX -->
        <div v-if="paxToRefund && paxToRefund.length > 0">
            <h3>Pax</h3>

            <!-- TABLE Pax-->
            <table class="w-100 dark mb-4">

                <tr class="fs-small">
                    <th class="pb-2 w-50">Description</th>
                    <th class="pb-2 text-center">Seller</th>
                    <th class="pb-2 text-center">Original Qtd.</th>
                    <th class="pb-2 text-center">Price/unit</th>
                    <th class="pb-2 text-center">Qtd. to Remove</th>
                </tr>

                <tr class="extraRow border-bottom-light border-top-light" v-for="pax in paxToRefund">
                    <td class="darker fs-large pl-2">{{ pax.bookingGenderPrice.audienceTypeDescription }}</td>
                    <td class="fs-small text-center">{{ itemSellerName(pax.bookingGenderPrice) }}</td>
                    <td class="fs-small text-center">{{ pax.bookingGenderPrice.quantityToBook }}</td>
                    <td class="fs-small text-center" v-html="paxPrice(pax)"></td>
                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeRefundQtd('remove', pax)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <input
                            type="text"
                            placeholder="0"
                            min="0"
                            class="text-center fs-larger px-1 py-0 bg-lighter darker"
                            style="width: 2.2rem"
                            v-model="pax.quantity"
                            @keyup="refundQtdChanged($event, pax)"
                            @focus="refundQtdFocused(pax)"
                            v-numInt
                            >
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeRefundQtd('add', pax)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
            </table>
        </div>

        <!-- EXTRAS -->
        <div v-if="extrasToRefund && extrasToRefund.length > 0">
            <h3>Extras</h3>

            <!-- TABLE Extra-->
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="pb-2 w-50">Description</th>
                    <th class="pb-2 text-center">Seller</th>
                    <th class="pb-2 text-center">Original Qtd.</th>
                    <th class="pb-2 text-center">Price/unit</th>
                    <th class="pb-2 text-center">Qtd. to Remove</th>
                </tr>

                <tr class="extraRow border-bottom-light border-top-light" v-for="extra in extrasToRefund">
                    <td class="darker fs-large pl-2">{{ extra.bookingComponent.componentName + ' - ' + extra.bookingComponent.componentPriceName }}</td>
                    <td class="fs-small text-center">{{ itemSellerName(extra.bookingComponent) }}</td>
                    <td class="fs-small text-center">{{ extra.bookingComponent.quantity }}</td>
                    <td class="fs-small text-center" v-html="extraPrice(extra)"></td>
                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeRefundQtd('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" v-model="extra.quantity" @keyup="refundQtdChanged($event, extra)" @focus="refundQtdFocused(extra)">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeRefundQtd('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
            </table>

            <div v-if="reservationHasDiscount" class="text-right dark mb-4">
                * Total discount applied to current booking.
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    data() {
        return {
            perGroupRefundMsg: 'This booking (Per Group - Price per Group) does not allow pax item value refund.'
        }
    },
    props: {
        value: {
            type: Array
        },
        calculations:{
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getSelectedReservation'
        ]),
        isPricePerGroupPerGroup() {
            return this.getSelectedReservation.flags.isGroup && !this.getSelectedReservation.flags.isGroupPerCategory;
        },
        refundArray() {
            return this.value.refundItems;
        },
        paxToRefund() {
            let response = this.value.filter(paxItem => typeof paxItem.bookingGenderPrice !== "undefined");

            response.map(item => {
                item.bookingGenderPrice.discount = this.getSelectedReservation.attachDiscount;
                item.bookingGenderPrice.refund = this.calculations.refund.details.find(refund =>
                    refund.category === "BookingGenderPrice" &&
                    refund.audienceType === item.bookingGenderPrice.audienceType &&
                    refund.audienceTypeDescription === item.bookingGenderPrice.audienceTypeDescription &&
                    refund.audienceTypeGroup === item.bookingGenderPrice.audienceTypeGroup);
                return item;
            });

            if (this.isPricePerGroupPerGroup) {
                return response.filter(item => item.bookingGenderPrice.genderPriceType !== 3);
            }

            return response;
        },
        extrasToRefund() {
            let response = this.value.filter(paxItem => typeof paxItem.bookingComponent != "undefined");

            response.map(item => {
                item.bookingComponent.discount = this.getSelectedReservation.attachDiscount;
                item.bookingComponent.refund = this.calculations.refund.details.find(refund =>
                    refund.category === "BookingComponent" &&
                    refund.categoryId === item.bookingComponent.componentPrice.id);
                return item;
            });

            return response;
        },
        reservationHasDiscount() {
            return this.getSelectedReservation.attachDiscount && this.getSelectedReservation.attachDiscount.value && this.getSelectedReservation.attachDiscount.value > 0;
        }
    },
    methods:{
        itemSellerName(item) {
            if (!item || !item.channel) {
                return '';
            }
            
            return item && item.channel? item.channel.name : '';
        },
        paxPrice(pax) {
            if (pax.bookingGenderPrice.discount && pax.bookingGenderPrice.discount.value > 0 && pax.bookingGenderPrice.grossprice !== pax.bookingGenderPrice.refund.curatedGrossPrice) {
                let output = `<strike class="text-nowrap">${this.formatPrice(pax.bookingGenderPrice.grossprice)} €</strike>`;
                if (pax.bookingGenderPrice.discount.valueType == 1) {
                    output += `<span class="fs-smaller ml-2 text-nowrap">${pax.bookingGenderPrice.discount.value} %*</span>`;
                }
                output += `<div class="bold">${this.formatPrice(pax.bookingGenderPrice.refund.curatedGrossPrice)} €</div>`;

                return output;

            } else {
                return `${this.formatPrice(pax.bookingGenderPrice.grossprice)} €`;
            }
        },
        extraPrice(extra) {
            if (extra.bookingComponent.discount && extra.bookingComponent.discount.value > 0 && extra.bookingComponent.grossPrice !== extra.bookingComponent.refund.curatedGrossPrice) {
                let output = `<strike class="text-nowrap">${this.formatPrice(extra.bookingComponent.grossPrice)} €</strike>`;
                if (extra.bookingComponent.discount.valueType == 1) {
                    output += `<span class="fs-smaller ml-2 text-nowrap">${extra.bookingComponent.discount.value} %*</span>`;
                }
                output += `<div class="bold">${this.formatPrice(extra.bookingComponent.refund.curatedGrossPrice)} €</div>`;

                return output;

            } else {
                return `${this.formatPrice(extra.bookingComponent.grossPrice)} €`;
            }
        },
        changeRefundQtd(action, item) {
            let upperLimit = item.bookingGenderPrice? item.bookingGenderPrice.quantityToBook : item.bookingComponent.quantity;

            if(action == "add"){
                if(item.quantity < upperLimit){
                    item.quantity++;
                    this.updateOutput();
                }
            } else {
                if(item.quantity > 0){
                    item.quantity--;
                    this.updateOutput();
                }
            }
        },
        somethingChanged() {
            this.$emit('change', this.value);
        },
        updateOutput() {
            this.$emit('input', this.value);
            this.somethingChanged();
        },
        refundQtdChanged(evt, item) {
            let upperLimit = item.bookingGenderPrice? item.bookingGenderPrice.quantityToBook : item.bookingComponent.quantity;

            if (Number(item.quantity) > upperLimit) {
                item.quantity = upperLimit;
            } else if (Number(item.quantity) < 0) {
                item.quantity = 0;
            }
            this.$emit('change', this.value);
        },
        refundQtdFocused() {},
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ReduceQuantity.vue?b6f6d11e